import { render, staticRenderFns } from "./camp-archives.vue?vue&type=template&id=3fd130e0&scoped=true&"
import script from "./camp-archives.vue?vue&type=script&lang=js&"
export * from "./camp-archives.vue?vue&type=script&lang=js&"
import style0 from "./camp-archives.vue?vue&type=style&index=0&id=3fd130e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd130e0",
  null
  
)

export default component.exports